import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import defaultBanner from '../../assets/img/casestudy/1.png';

const CaseStudySection1 = ({
    title,
    description,
    buttons,
    breadcrumb,
    backgroundImage
}) => {
    // Default values for the main Case Study gallery page
    const finalTitle = title || (
        <>
            <span className="text-primary">Case</span> Studies
        </>
    );

    const bgImage = backgroundImage || defaultBanner;

    return (
        <section
            className="casestudy-hero"
            style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url(${bgImage.src || bgImage})`
            }}
        >
            <div className="casestudy-hero-content">
                <h1>{finalTitle}</h1>

                {breadcrumb && (
                    <div className="casestudy-breadcrumb">
                        {breadcrumb.map((item, index) => (
                            <span key={index}>
                                <span className="breadcrumb-dot">•</span>
                                {item}
                            </span>
                        ))}
                    </div>
                )}

                {description && (
                    <p className="casestudy-description">
                        {description}
                    </p>
                )}

                {buttons && (
                    <div className="casestudy-hero-btns">
                        {buttons}
                    </div>
                )}
            </div>
        </section>
    );
};

export default CaseStudySection1;
